namespace RioERP.Masters {
    export namespace PermissionKeys {
        export const General = "Masters:General";

        namespace MastersManagement {
            export const Delete = "Masters:MastersManagement:Delete";
            export const Modify = "Masters:MastersManagement:Modify";
            export const View = "Masters:MastersManagement:View";
        }
    }
}
